import { URLS } from 'constants/urls'

class Locations {
  private getPathname(
    path: string,
    isOperator: boolean,
    companyId: string | number
  ) {
    return `${path}${isOperator ? `/${companyId}` : ''}`
  }

  stopSales = (isOperator: boolean, companyId: string | number) =>
    this.getPathname(`${URLS.FLEET}${URLS.STOP_SALES}`, isOperator, companyId)

  equipments = (isOperator: boolean, companyId: string | number) =>
    this.getPathname(`${URLS.FLEET}${URLS.EQUIPMENTS}`, isOperator, companyId)
}

export const locations = new Locations()
